// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"categories_wrapper__uviO8","card":"categories_card__V9EU_"};